<div class="main-container">
  <div class="pie-title">
    <span>
      {{ "page.revenuesummary" | translate }}
    </span>
  </div>
  <!-- <ng-container *ngIf="chart"> -->
  <!-- <div [hidden]="!chart"> -->
  <canvas class="my-4 w-100" id="pie" width="900" height="380">{{
    chart
  }}</canvas>
  <!-- </div> -->
  <!-- </ng-container> -->
</div>
